export class PanelCount {
  completeCount: number = 0;
  remainingCount: number = 0;
  remainingVerticalBoardsCount: number = 0; // pour la pose verticale
}
